import { render, staticRenderFns } from "./LibraryImageModal.vue?vue&type=template&id=1324deba&scoped=true&"
import script from "./LibraryImageModal.vue?vue&type=script&lang=js&"
export * from "./LibraryImageModal.vue?vue&type=script&lang=js&"
import style0 from "./LibraryImageModal.vue?vue&type=style&index=0&id=1324deba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1324deba",
  null
  
)

export default component.exports